export enum SectionTileMenuEnum {
  UNSCHEDULE_COURSE = 'UNSCHEDULE_COURSE',
  UNSCHEDULE_SECTIONS = 'UNSCHEDULE_SECTIONS',
  DROP_COURSE = 'DROP_COURSE',
  DROP_SECTIONS = 'DROP_SECTIONS',
  DROP_ENFORCED_COREQS = 'DROP_ENFORCED_COREQS',
  REMOVE_WAITLIST = 'REMOVE_WAITLIST',
  WITHDRAW = 'WITHDRAW',

  // remove
  DROP_MULT_COURSE = 'DROP_MULT_COURSE',
  UNSCHEDULE_SECTION = 'UNSCHEDULE_SECTION',
  UNSCHEDULE_ALL_SECTION = 'UNSCHEDULE_ALL_SECTION',

  // misc
  SWAP_SECTION = 'SWAP_SECTION',
  SWAP_COURSE = 'SWAP_COURSE',
  SCHEDULE_AGAIN = 'SCHEDULE_AGAIN'
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/course_scheduler/types/section_tile_menu_enum.ts